module.exports = __webpack_public_path__ + "static/img/kit_83-1100-483-753.462c15e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/kit_83-1100-483-753.jpg
// module id = uPT6
// module chunks = 0